import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import SelectedConnectorWrapper from './elements-container/selected-connector-wrapper';
import SelectedGroupWrapper from './elements-container/selected-group-wrapper';
import SelectedTableWrapper from './elements-container/selected-table-wrapper';
import SelectedImageWrapper from './elements-container/selected-image-wrapper';
import SelectedShapeWrapper from './elements-container/selected-shape-wrapper';

import SelectedChartWrapper from './elements-container/selected-chart-wrapper';
import SelectedSmartArtWrapper from './elements-container/selected-smart-art-wrapper';
import { MouseEvent } from 'react';

export interface SelectElementWrapper {
    isSelected?: boolean;
    selectable?: boolean;
    canBeConnected?: boolean;
    showSelectBorder?: boolean;
    borderDraggable?: boolean;
    canRotate?: boolean;
    isControlValuesChanging?: boolean;
    resizeVertical?: boolean;
    resizeHorizontal?: boolean;
    draggable?: boolean;
    onBorderClick?(e: MouseEvent<HTMLOrSVGElement>): void;
}

export default function selectedElementWithType(elementType: string) {
    switch (elementType) {
        case UIModelType.GROUP:
            return SelectedGroupWrapper;
        case UIModelType.TABLE:
            return SelectedTableWrapper;
        case UIModelType.SHAPE:
            return SelectedShapeWrapper;
        case UIModelType.IMAGE:
            return SelectedImageWrapper;
        case UIModelType.CONNECTOR:
            return SelectedConnectorWrapper;
        case UIModelType.CHART:
            return SelectedChartWrapper;
        case UIModelType.SMART_ART:
            return SelectedSmartArtWrapper;
        default:
            return null;
    }
}
